import { translateFunc } from "client/utils/translateFunc";
import { useDelete } from "./useDelete";
import { stopPropagation } from "client/utils/stopPropagation";

export interface DeleteProps {
    handleClose: () => void;
}

export const Delete = ({ handleClose }: DeleteProps) => {
    const { handleDelete } = useDelete();

    return (
        <div className="flex flex-col items-center py-4" onClick={stopPropagation()}>
            <div className="text-center capitalize text-2xl mb-8">{translateFunc("common:delete-all-images")}?</div>
            <div
                className={`w-full text-xl bg-irRed-400 text-white py-2 text-center capitalize rounded-xl mb-4`}
                onClick={() => {
                    handleDelete();
                    handleClose();
                }}
            >
                {translateFunc("common:yes")}
            </div>
            <div
                className={`w-full text-xl bg-irGray-200 dark:bg-darkSurface-300 py-2 text-center capitalize rounded-xl mb-4`}
                onClick={handleClose}
            >
                {translateFunc("common:no")}
            </div>
        </div>
    );
};
